import { render, staticRenderFns } from "./sysModuleAddMenus.vue?vue&type=template&id=01ca6f20&scoped=true&"
import script from "./sysModuleAddMenus.vue?vue&type=script&lang=js&"
export * from "./sysModuleAddMenus.vue?vue&type=script&lang=js&"
import style0 from "./sysModuleAddMenus.vue?vue&type=style&index=0&id=01ca6f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca6f20",
  null
  
)

export default component.exports